import React, { useState } from "react";
import {
    Mail,
    Lock,
    User,
    Phone,
    Eye,
    EyeOff
} from "lucide-react";
import { Link } from "react-router-dom";
import VerifyOtp from "./VerifyOtp";
import { useSearchParams } from 'react-router-dom';
import reapi from "../apis/reapi";
import { toast } from "react-toastify";
import Btncom from "../Components/Btncom";


export default function Signup() {
    const [searchParams, setSearchParams] = useSearchParams();


    const refer = searchParams.get('refer');

    const [showPassword, setShowPassword] = useState(false);

window.document.title = 'Signup'
    const [otpsent, setotpsent] = useState(false);
    const [loading, setloading] = useState(false);


    const [formData, setFormData] = useState({
        name: "",
        email: "",
        password: "",
        mobile: "",
        referralcode: refer
    });

    function isValidEmail(email) {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    }




    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
    };


    const handlebtnclick = async (e) => {
        await setloading(true)
        if (isValidEmail(formData.email) && formData.password !== '' && formData.mobile !== "" && formData.name !== '') {

            await reapi.post(`/signup`, formData).then((res) => {
                if (res?.data.status) {
                    setotpsent(true)
                    console.log(res.data)
                    toast.success(res?.data.message)
                } else {
                    toast.error(res?.data.message)

                }
            }).catch((e) => {

                toast.error(e?.response?.data.message)

            })

        } else {
            toast.error('Please fill all Data')

        }
        await setloading(false)
    }
    // https://i.ibb.co/LdHSw0TP/shipless.png


    const handleRedirect = (url) => {
        // Sends the user to the specified external website URL
        window.location.href = url;
    };

    return (
        !otpsent ? <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-orange-100 flex items-center justify-center px-4">
            <div className="w-full max-w-md">
                {/* Logo */}
                <div className="text-center mb-8">
                    <img src="https://i.ibb.co/HTJMwrc0/crop-logo-shipless.png" width={350} style={{ textAlign: 'center', display: 'unset' }} />
                    <p className="text-gray-500 mt-2">
                        AI Powered Shipping Optimizer for Meesho Sellers
                    </p>
                </div>

                {/* Card */}
                <div className="bg-white/80 backdrop-blur-lg border border-white rounded-3xl shadow-xl p-8">
                    <h2 className="text-2xl font-bold text-gray-800">
                        Create Account
                    </h2>

                    <p className="text-gray-500 mt-1 mb-6">
                        Reduce Shipping. Increase Profit.
                    </p>

                    {/* Full Name */}
                    <div className="mb-4">
                        <label className="text-sm font-medium">
                            Full Name
                        </label>

                        <div className="flex items-center border rounded-xl mt-2 px-3">
                            <User size={18} />
                            <input
                                label="Name" name="name" value={formData.name} onChange={handleChange}
                                type="text"
                                placeholder="John Doe"
                                className="w-full p-3 outline-none"
                            />
                        </div>
                    </div>

                    {/* Mobile */}
                    <div className="mb-4">

                        <label className="text-sm font-medium">
                            Mobile Number
                        </label>

                        <div className="flex items-center border rounded-xl mt-2 px-3">
                            <Phone size={18} />
                            <input
                                label="Mobile" name="mobile" value={formData.mobile}
                                onChange={(e) => {
                                    const value = e.target.value.replace(/\D/g, "");

                                    if (value.length <= 10) {
                                        setFormData({
                                            ...formData,
                                            mobile: value,
                                        });
                                    }
                                }}
                                type="text"
                                placeholder="9876543210"
                                className="w-full p-3 outline-none"
                            />
                        </div>
                    </div>

                    {/* Email */}
                    <div className="mb-4">
                        <label className="text-sm font-medium">
                            Email Address
                        </label>

                        <div className="flex items-center border rounded-xl mt-2 px-3">
                            <Mail size={18} />
                            <input
                                label="Email" name="email" value={formData.email} onChange={handleChange}
                                type="email"
                                placeholder="you@example.com"
                                className="w-full p-3 outline-none"
                            />
                        </div>
                    </div>

                    {/* Password */}
                    <div className="mb-6">
                        <label className="text-sm font-medium">
                            Password
                        </label>

                        <div className="flex items-center border rounded-xl mt-2 px-3">
                            <Lock size={18} />

                            <input
                                type={
                                    showPassword
                                        ? "text"
                                        : "password"
                                }
                                label="Password" name="password" value={formData.password} onChange={handleChange}
                                placeholder="Minimum 6 characters"
                                className="w-full p-3 outline-none"
                            />

                            <button
                                type="button"
                                onClick={() =>
                                    setShowPassword(
                                        !showPassword
                                    )
                                }
                            >
                                {showPassword ? (
                                    <EyeOff size={18} />
                                ) : (
                                    <Eye size={18} />
                                )}
                            </button>
                        </div>
                    </div>

                    {/* Signup Button */}
                    {/* <button onClick={handlebtnclick} className="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-3 rounded-xl transition">
                        Create Free Account
                    </button> */}

                    <Btncom onClick={handlebtnclick} loading={loading} title={'Create Free Account'} />

                    {/* Divider */}
                    <div className="flex items-center my-6">
                        <div className="flex-1 border-t"></div>
                        <span className="px-3 text-sm text-gray-400">
                            OR
                        </span>
                        <div className="flex-1 border-t"></div>
                    </div>

                    {/* Login */}
                    <Link to='/login'>

                        <button className="w-full border border-[#551cd1] text-[#551cd1] py-3 rounded-xl hover:bg-orange-50 transition">
                            Login →
                        </button>
                    </Link>

                    <p className="text-center text-xs text-gray-500 mt-6">
                        By creating an account you agree to
                        <span onClick={()=>handleRedirect('https://www.shipless.in/terms')} style={{ color: 'red', cursor: 'pointer' }}> Terms </span> & <span onClick={()=>handleRedirect('https://www.shipless.in/privacy')} style={{ color: 'red', cursor: 'pointer' }}> Privacy Policy </span>
                    </p>
                </div>
            </div>
        </div> : <VerifyOtp form={formData} />
    );
}